import { useState } from 'react';
import
{
  StyledCollapse,
  StyledAlert,
  StyledIconButton,
  StyledCloseIcon,
  TextContainer,
} from './ManagedModeBanner.styles';
import FeedbackText from '../../Typography/FeedbackText/FeedbackText';
import BannerButton from '../../Buttons/BannerButton/BannerButton';
import { Box, Stack } from '@mui/material';

const ManagedModeBanner = ({ open, showClose, text, isSuccess, showBtn, btnText, onClick, isFixed, onClose }) =>
{
  const [show, setShow] = useState(open);

  const handleBannerClose = () =>
  {
    setShow(false);
    // call setTimeout to allow close transition to complete before resetting open state
    setTimeout(() => onClose(), 500);
  };

  return (
    <StyledAlert
      direction={'row'}
      justifyContent="space-around"
      alignItems="center"
      fixed={isFixed ? 'true' : undefined}
      success={isSuccess ? 'true' : undefined}
    >
      <TextContainer>
        <FeedbackText
          text={text}
          isSuccess={isSuccess}
        />

      </TextContainer>


      {
        showBtn && btnText && onClick &&
        <BannerButton
          text={btnText}
          onClick={onClick}
          isSuccess={isSuccess}
        />
      }

    </StyledAlert>
  );
};

export default ManagedModeBanner;
